// @flow strict

import * as React from 'react';

import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Text, Hide } from '@gandi/ui';

import { useAssetPath } from 'gandi.react-asset-path';

type Props = {
  application?: ApplicationSummary,
};

export default function OffersIntro({
  application,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const assetPath = useAssetPath(
    `img/hosting_${application?.name || 'only'}.svg`,
  );

  return (
    <Base flex gap="small" marginBottom="base">
      <Base flexGrow1>
        <Base tagName="h2" marginBottom="small">
          {mapTags(__('1. Pick a plan [[withApp:]]'), () => ({
            withApp: application ? (
              <Text>
                {__('for your Hosting with %(appName)s', {
                  appName: application?.name_label,
                })}
              </Text>
            ) : (
              <Text>{__('for your Web Hosting')}</Text>
            ),
          }))}{' '}
        </Base>
        <Base tagName="p" margin="none">
          {__(
            'Choose your hosting size, then choose your free domain name at the next step.',
          )}
        </Base>
      </Base>
      <Hide until="sm">
        <img alt="" height="80" src={assetPath} width="80" />
      </Hide>
    </Base>
  );
}
